(function (angular, ToyotaConsts) {
  "use strict";

  var HTTP_OK = 200;
  var HTTP_NOT_FOUND = 404;

  var SERVICE_INTERVALS_LIMIT = 10;

  angular.module("Toyota.Directives").directive("tyServicePricingTool", function () {
    var controller = [
      "$scope",
      "$rootScope",
      "$filter",
      "API",
      "VIN",
      "$attrs",
      "$timeout",
      "$location",
      "$interval",
      "$analytics",
      function ($scope, $rootScope, $filter, API, VIN, $attrs, $timeout, $location, $interval, $analytics) {
        // Private variables
        var toyotaServiceAdvantage = "TSA";
        var validators = {
          Rego: {
            pattern: /^[A-Za-z0-9]{1,9}$/,
          },
          Odometer: {
            pattern: /^\d+$/,
          },
        };

        // Public variables
        $scope.servicePricingTool = $scope.servicePricingTool ? $scope.servicePricingTool : {};

        $scope.servicePricingTool.tabs = {
          Rego: 1,
          Vin: 2,
          Model: 3,
        };

        $scope.servicePricingTool.vehicleListings = {
          ModelsList: null,
          GradesList: null,
          VariantsList: null,
          ServiceIntervals: null,
          PricingTypeList: null,
        };

        $scope.servicePricingTool.vehicle = {
          Rego: null,
          State: null,
          Model: null,
          Grade: null,
          Variant: null,
          Vin: null,
          VehicleInfo: null,
          ServiceDetails: null,
          SelectedService: null,
          SelectedServiceCode: null,
          Odometer: null,
        };

        $scope.servicePricingTool.loadingState = {
          isVariantLoading: false,
          isModelLoading: false,
          isQuoteLoading: false,
          isQuoteUpdating: false,
        };

        $scope.servicePricingTool.tokenService = {
          accessToken: $attrs.accesstoken,
          interval: 900000, // 15 mins == 900000
        };

        $scope.servicePricingTool.serviceActionTypesOrder = {
          Replace: 3,
          Tighten: 2,
          Inspect: 1,
        };

        $scope.servicePricingTool.errorState = null;
        $scope.servicePricingTool.errorCodes = {
          notFound: "NOT_FOUND",
          serverError: "SERVER_ERROR|BAD_REQUEST|BAD_MODEL|BAD_GRADE|BAD_VARIANT",
          variantNotFound: "NO_VARIANT",
          any: "^(?!HTTP_REQUEST_CANCELLED).+$",
        };

        $scope.servicePricingTool.loadingPromise = null;
        $scope.servicePricingTool.isHttpRequestCancelled = false;
        $scope.servicePricingTool.isPrintMode = false;
        $scope.servicePricingTool.quoteDate = null;

        // Watch tasks - Rego
        $scope.$watch("servicePricingTool.vehicle.Rego", function (newValue) {
          if (newValue) {
            $scope.servicePricingTool.vehicle.Rego = $scope.servicePricingTool.vehicle.Rego.toUpperCase();
          }
        });

        $scope.$watch("servicePricingTool.vehicle.State", function (newValue) {
          if (newValue && $scope.servicePricingTool.isFormReady()) {
            $scope.servicePricingTool.track("gaClick", "Rego", "State Selected - {0}", [newValue]);
          }
        });

        // Watch tasks - VIN
        $scope.$watch("servicePricingTool.vehicle.Vin", function (newValue) {
          if (newValue) {
            $scope.servicePricingTool.vehicle.Vin = $scope.servicePricingTool.vehicle.Vin.toUpperCase();
          }
        });

        // Watch tasks - Model
        $scope.$watch("servicePricingTool.vehicle.Model", function (newValue) {
          if (newValue && $scope.servicePricingTool.isFormReady()) {
            $scope.servicePricingTool.track(
              "gaClick",
              "Model",
              $filter("formatArgs")("Model - {0}", [$scope.servicePricingTool.vehicle.Model.Name])
            );
          }
        });

        $scope.$watch("servicePricingTool.vehicle.Grade", function (newValue) {
          if (newValue && $scope.servicePricingTool.isFormReady()) {
            $scope.servicePricingTool.track(
              "gaClick",
              "Model",
              $filter("formatArgs")("Grade - {0}", [$scope.servicePricingTool.vehicle.Grade.Name])
            );
          }
        });

        $scope.$watch("servicePricingTool.vehicle.Variant", function (newValue) {
          if (newValue && $scope.servicePricingTool.isFormReady()) {
            $scope.servicePricingTool.track(
              "gaClick",
              "Model",
              $filter("formatArgs")("Type - {0}", [$scope.servicePricingTool.vehicle.Variant.MarketingDescription])
            );
          }
        });

        // Watch Tasks - Quote
        $scope.$watchGroup(
          ["servicePricingTool.vehicle.VehicleInfo", "servicePricingTool.vehicle.ServiceDetails"],
          function (newValues, oldValues) {
            if (newValues !== oldValues) {
              if (newValues[0] !== null && newValues[1] !== null) {
                $scope.servicePricingTool.showingQuote = true;
              }
            }
          }
        );

        $scope.$watch("servicePricingTool.showingQuote", function (newValue) {
          if (newValue) {
            // Update the querystring when we're showing a quote
            $location.search({
              vin: $scope.servicePricingTool.vehicle.Vin,
              state: $scope.servicePricingTool.vehicle.State,
              rego: $scope.servicePricingTool.vehicle.Rego,
              model: $scope.servicePricingTool.vehicle.Model ? $scope.servicePricingTool.vehicle.Model.Name : null,
              grade: $scope.servicePricingTool.vehicle.Grade ? $scope.servicePricingTool.vehicle.Grade.GradeId : null,
              variant: $scope.servicePricingTool.vehicle.Variant ? $scope.servicePricingTool.vehicle.Variant.ID : null,
              odometer: $scope.servicePricingTool.vehicle.Odometer,
              service: $scope.servicePricingTool.vehicle.SelectedServiceCode,
              p: $scope.servicePricingTool.isPrintMode ? 1 : null,
            });
          }
        });

        $scope.$watch("servicePricingTool.vehicle.SelectedService", function (newValue, oldValue) {
          if (newValue) {
            // updates the accordion
            expandSelectedService();
            $rootScope.$broadcast("accordion-content-updated");
          }

          /*
           * Only update that URL when the user has changed the selection
           * and we have a default value, and a changed value
           */
          if (newValue && oldValue) {
            // updates the url
            $location.search({
              vin: $scope.servicePricingTool.vehicle.Vin,
              state: $scope.servicePricingTool.vehicle.State,
              rego: $scope.servicePricingTool.vehicle.Rego,
              model: $scope.servicePricingTool.vehicle.Model ? $scope.servicePricingTool.vehicle.Model.Name : null,
              grade: $scope.servicePricingTool.vehicle.Grade ? $scope.servicePricingTool.vehicle.Grade.GradeId : null,
              variant: $scope.servicePricingTool.vehicle.Variant ? $scope.servicePricingTool.vehicle.Variant.ID : null,
              odometer: $scope.servicePricingTool.vehicle.Odometer,
              service: isFirstOrDefaultService($scope.servicePricingTool.vehicle.SelectedService.code)
                ? null
                : $scope.servicePricingTool.vehicle.SelectedService.code,
              p: $scope.servicePricingTool.isPrintMode ? 1 : null,
            });

            if (!angular.equals(newValue, oldValue)) {
              if ($scope.servicePricingTool.isQuoteReady()) {
                var tab = $scope.servicePricingTool.getSelectedTabName();
                $scope.servicePricingTool.track("gaClick", "{0} - Quote", "Change - {1}", [
                  tab,
                  newValue.formattedName,
                ]);
              }
            }
          }
        });

        $scope.$on("$locationChangeSuccess", function () {
          var query = $location.search();

          $scope.servicePricingTool.vehicle.SelectedServiceCode = query.service;
          $scope.servicePricingTool.vehicle.Odometer = query.odometer;
          $scope.servicePricingTool.isPrintMode = query.p;

          $scope.servicePricingTool.resetErrorState();

          // Prefill the results
          if (!$scope.servicePricingTool.hasCompleteServiceQuote()) {
            // Update the state based on query string values
            if (query.vin && VIN.isValid(query.vin)) {
              $scope.servicePricingTool.showingQuote = true;
              $scope.servicePricingTool.showingServiceOptions = $scope.servicePricingTool.tabs.Vin;
              $scope.servicePricingTool.vehicle.Vin = query.vin;
              $scope.servicePricingTool.getServiceQuoteByVin();
            } else if (query.rego && query.state && validators.Rego.pattern.test(query.rego)) {
              $scope.servicePricingTool.showingQuote = true;
              $scope.servicePricingTool.showingServiceOptions = $scope.servicePricingTool.tabs.Rego;
              $scope.servicePricingTool.vehicle.Rego = query.rego;
              $scope.servicePricingTool.vehicle.State = query.state;
              $scope.servicePricingTool.getServiceQuoteByRego();
            } else if (query.model && query.grade && query.variant) {
              var grades;
              var promise = $.Deferred();

              $scope.servicePricingTool.showingServiceOptions = $scope.servicePricingTool.tabs.Model;

              // Set the model
              var selectedModel = $scope.servicePricingTool.vehicleListings.ModelsList.filter(function (model) {
                return model.Name === query.model;
              })[0];

              if (selectedModel) {
                grades = selectedModel.Grades;
                $scope.servicePricingTool.vehicle.Model = selectedModel;
                $scope.servicePricingTool.vehicleListings.GradesList = grades;
              } else {
                return handleError({
                  status: "BAD_MODEL",
                });
              }

              // Set the grades
              var selectedGrade = grades.filter(function (grade) {
                return grade.GradeId === query.grade;
              })[0];

              if (selectedGrade) {
                $scope.servicePricingTool.vehicle.Grade = selectedGrade;
              } else {
                return handleError({
                  status: "BAD_GRADE",
                });
              }

              var variantsPromise = function (response) {
                if (response.status !== HTTP_OK) {
                  return promise.reject(response);
                }

                var results = response.data.Data;

                $scope.servicePricingTool.vehicleListings.VariantsList = results;

                var selectedVariant = results.filter(function (variant) {
                  return variant.ID === query.variant;
                })[0];

                if (selectedVariant) {
                  $scope.servicePricingTool.vehicle.Variant = selectedVariant;
                } else {
                  return promise.reject({
                    status: "BAD_VARIANT",
                  });
                }

                return promise.resolve(response);
              };

              getVariants(selectedGrade.GradeId)
                .then(variantsPromise, handleError)
                .then(function () {
                  $scope.servicePricingTool.showingQuote = true;
                  $scope.servicePricingTool.getServiceQuoteByModel();
                })
                .catch(handleError);
            }
          } else if (!angular.equals(query, {})) {
            // We set showingQuote to true here for when the user hits the forward button
            $scope.servicePricingTool.showingQuote = true;
            setScheduledServices();
          }

          // If the query object is empty, show the form
          if (angular.equals(query, {})) {
            $scope.servicePricingTool.showingQuote = false;
          }

          return undefined;
        });

        // Public methods

        /**
         * getSelectedTabName - get the currently active tab name from its integer value
         *
         * @return {string} the tab name e.g. Rego, Vin, Model
         */
        $scope.servicePricingTool.getSelectedTabName = function () {
          return Object.keys($scope.servicePricingTool.tabs).filter(function (tab) {
            return $scope.servicePricingTool.tabs[tab] === $scope.servicePricingTool.showingServiceOptions;
          })[0];
        };

        /**
         * getServiceQuoteByModel - gets a service quote by model
         *
         * @param {boolean} updateOnly  if true, we only call the scheuled services API as we already have the vehicle info
         * @return {void}
         */
        $scope.servicePricingTool.getServiceQuoteByModel = function (updateOnly) {
          var model = $scope.servicePricingTool.vehicle.Model;
          var grade = $scope.servicePricingTool.vehicle.Grade;
          var variant = $scope.servicePricingTool.vehicle.Variant;
          var materialCode = $scope.servicePricingTool.vehicle.Variant.BaseMaterialCode;
          var code = $scope.servicePricingTool.vehicle.SelectedServiceCode;
          var odometer = $scope.servicePricingTool.vehicle.Odometer;
          var modelCode = $scope.servicePricingTool.vehicle.Variant.EngineModelNumber;
          var ssn = $scope.servicePricingTool.vehicle.Variant.SSN;
          var suffix = $scope.servicePricingTool.vehicle.Variant.EngineBaseSuffix;

          // Clear other settings
          $scope.servicePricingTool.vehicle = setVehicleValues(
            {
              Model: model,
              Grade: grade,
              Variant: variant,
              SelectedServiceCode: code,
              Odometer: odometer,
            },
            updateOnly
          );

          var urlVehicleInfo = $filter("formatArgs")(ToyotaConsts.API.ServiceQuote.VehicleInfo + "/material/{0}", [
            materialCode,
          ]);
          var urlServiceDetails = $filter("formatArgs")(
            ToyotaConsts.API.ServiceQuote.ServiceDetails + "/codes?ssn={0}&modelCode={1}&suffix={2}",
            [ssn, modelCode, suffix]
          );

          if (odometer) {
            urlServiceDetails += $filter("formatArgs")("&odometer={0}", [odometer]);
          }

          if ($scope.servicePricingTool.isFormReady()) {
            $scope.servicePricingTool.track("gaClick", "Model", "Get Quote - {0}/{1}/{2}", [
              model.Name,
              grade.Name,
              variant.MarketingDescription,
            ]);
          }

          cancelExistingPromise();

          $scope.servicePricingTool.loadingPromise = getServiceQuote(urlVehicleInfo, urlServiceDetails, updateOnly);
        };

        /**
         * getServiceQuoteByRego - gets a service quote by registration
         *
         * @param {boolean} updateOnly  if true, we only call the scheuled services API as we already have the vehicle info
         * @return {void}
         */
        $scope.servicePricingTool.getServiceQuoteByRego = function (updateOnly) {
          var regoNumber = $scope.servicePricingTool.vehicle.Rego;
          var state = $scope.servicePricingTool.vehicle.State;
          var code = $scope.servicePricingTool.vehicle.SelectedServiceCode;
          var odometer = $scope.servicePricingTool.vehicle.Odometer;

          // Clear other settings
          $scope.servicePricingTool.vehicle = setVehicleValues(
            {
              Rego: regoNumber,
              State: state,
              SelectedServiceCode: code,
              Odometer: odometer,
            },
            updateOnly
          );

          var urlVehicleInfo = $filter("formatArgs")(
            ToyotaConsts.API.ServiceQuote.VehicleInfo + "?registrationNumber={0}&state={1}",
            [regoNumber, state]
          );
          var urlServiceDetails = $filter("formatArgs")(
            ToyotaConsts.API.ServiceQuote.ServiceDetails + "?registrationNumber={0}&state={1}",
            [regoNumber, state]
          );

          if (odometer) {
            urlVehicleInfo += $filter("formatArgs")("&odometer={0}", [odometer]);
            urlServiceDetails += $filter("formatArgs")("&odometer={0}", [odometer]);
          }

          cancelExistingPromise();

          $scope.servicePricingTool.loadingPromise = getServiceQuote(urlVehicleInfo, urlServiceDetails, updateOnly);
        };

        /**
         * getServiceQuoteByVin - gets a service quote by VIN
         *
         * @param {boolean} updateOnly  if true, we only call the scheuled services API as we already have the vehicle info
         * @return {void}
         */
        $scope.servicePricingTool.getServiceQuoteByVin = function (updateOnly) {
          var vin = $scope.servicePricingTool.vehicle.Vin;
          var code = $scope.servicePricingTool.vehicle.SelectedServiceCode;
          var odometer = $scope.servicePricingTool.vehicle.Odometer;

          // Clear other settings
          $scope.servicePricingTool.vehicle = setVehicleValues(
            {
              Vin: vin,
              SelectedServiceCode: code,
              Odometer: odometer,
            },
            updateOnly
          );

          var urlVehicleInfo = $filter("formatArgs")(ToyotaConsts.API.ServiceQuote.VehicleInfo + "/{0}", [vin]);
          var urlServiceDetails = $filter("formatArgs")(ToyotaConsts.API.ServiceQuote.ServiceDetails + "/{0}", [vin]);

          if (odometer) {
            urlServiceDetails += $filter("formatArgs")("?odometer={0}", [odometer]);
          }

          cancelExistingPromise();

          $scope.servicePricingTool.loadingPromise = getServiceQuote(urlVehicleInfo, urlServiceDetails, updateOnly);
        };

        /**
         * getVehicleManufactureYear - The vehicle info API returns the year of manufacturer as a string
         *                             in the format YYYY-MM, so we need to apply some formatting to return
         *                             only the year
         *
         * @return {type}  description
         */
        $scope.servicePricingTool.getVehicleManufactureYear = function () {
          if (
            $scope.servicePricingTool.vehicle.VehicleInfo &&
            $scope.servicePricingTool.vehicle.VehicleInfo.manufacturedYear
          ) {
            return $scope.servicePricingTool.vehicle.VehicleInfo.manufacturedYear.split("-")[0];
          }

          return null;
        };

        /**
         * goToForm - This function removes the query string parameters,
         *            and removes all data retrieved from the API, and sets
         *            the showingQuote property to false.
         * @returns {void}
         */
        $scope.servicePricingTool.goToForm = function () {
          $location.search({});
          $scope.servicePricingTool.showingQuote = false;
          $scope.servicePricingTool.vehicle.SelectedServiceCode = null;
          $scope.servicePricingTool.vehicle.VehicleInfo = null;
          $scope.servicePricingTool.vehicle.ServiceDetails = null;
        };

        /**
         * hasAccessToken - This is used to show a global error block/hide the forms if there
         *                  is no valid access token
         *
         * @return {boolean}    true if we have a valid access token
         */
        $scope.servicePricingTool.hasAccessToken = function () {
          return !!$scope.servicePricingTool.tokenService.accessToken;
        };

        /**
         * hasCompleteServiceQuote
         *
         * @return {boolean}    true if both vehicle and service details are set
         */
        $scope.servicePricingTool.hasCompleteServiceQuote = function () {
          return (
            ($scope.servicePricingTool.vehicle.VehicleInfo && $scope.servicePricingTool.vehicle.ServiceDetails) ||
            $scope.servicePricingTool.loadingState.isQuoteUpdating
          );
        };

        /**
         * hasError - returns true if there are any errors of a particular status
         *            e.g. 404 or 500 on a particular tab
         *
         * @param  {string} serviceOption the selected tab e.g. Vin, Rego, Model
         * @param  {string} status        a property of $scope.servicePricingTool.errorCodes
         * @return {boolean}              true if there are any errors of a particular status
         */
        $scope.servicePricingTool.hasErrorOnTabWithStatus = function (serviceOption, status) {
          return (
            $scope.servicePricingTool.errorState &&
            $scope.servicePricingTool.errorState.error &&
            $scope.servicePricingTool.errorState.serviceOption === serviceOption &&
            new RegExp(status).test($scope.servicePricingTool.errorState.error.status)
          );
        };

        /**
         * hasError - returns true if there are any errors of a particular status
         *            e.g. 404 or 500
         *
         * @param  {string} status        a property of $scope.servicePricingTool.errorCodes
         * @return {boolean}              true if there are any errors of a particular status
         */
        $scope.servicePricingTool.hasErrorWithStatus = function (status) {
          return (
            $scope.servicePricingTool.errorState &&
            $scope.servicePricingTool.errorState.error &&
            new RegExp(status).test($scope.servicePricingTool.errorState.error.status)
          );
        };

        /**
         * isActiveModel - returns true if the active model is the same as the argument
         *
         * @param  {string} model   the model name
         * @return {boolean}        true if the active model is the same as the argument
         */
        $scope.servicePricingTool.isActiveModel = function (model) {
          if ($scope.servicePricingTool.vehicle.Model) {
            return $scope.servicePricingTool.vehicle.Model.Name === model;
          }

          return false;
        };

        /**
         * isFormComplete - returns true if the form is complete
         *
         * @return {boolean}    true if the form is complete
         */
        $scope.servicePricingTool.isFormComplete = function () {
          var tabs = $scope.servicePricingTool.tabs;
          var vehicle = $scope.servicePricingTool.vehicle;
          var result = false;

          switch ($scope.servicePricingTool.showingServiceOptions) {
            case tabs.Rego:
              result = $scope.servicePricingTool.isValidRego(vehicle.Rego) && vehicle.State;
              break;
            case tabs.Model:
              result = vehicle.Model && vehicle.Grade && vehicle.Variant;
              break;
            case tabs.Vin:
              result = $scope.servicePricingTool.isValidVin($scope.servicePricingTool.vehicle.Vin);
              break;
            default:
          }

          return result;
        };

        /**
         * isModelOrGradeSet - returns true if the Model or Grade is selected, used by the Grade dropdown
         *                     and its container
         *
         * @return {boolean}    true if the Model or Grade is selected, used by the Grade dropdown
         *                     and its container
         */
        $scope.servicePricingTool.isModelOrGradeSet = function () {
          return $scope.servicePricingTool.vehicle.Model || $scope.servicePricingTool.vehicleListings.GradesList;
        };

        /**
         * isGradeOrVariantSet - returns true if the Grade or Variant is selected, used by the Variant dropdown
         *                       and its container
         *
         * @return {boolean}    true if the Grade or Variant is selected, used by the Variant dropdown
         *                       and its container
         */
        $scope.servicePricingTool.isGradeOrVariantSet = function () {
          return $scope.servicePricingTool.vehicle.Grade || $scope.servicePricingTool.vehicleListings.VariantsList;
        };

        /**
         * isValidOdometer - determines if the odometer value is valid when the user has entered something
         *
         * @return {boolean} returns true if the regex matches, returns false if the regex doesn't match or the field is empty
         */
        $scope.servicePricingTool.isValidOdometer = function () {
          var odometer = $scope.servicePricingTool.vehicle.Odometer;
          return validators.Odometer.pattern.test(odometer);
        };

        /**
         * isInvalidOdometer - determines if the odometer value is invalid
         *
         * @return {boolean} returns true if the regex doesn't match, returns false if the regex matches or the field is empty
         */
        $scope.servicePricingTool.isInvalidOdometer = function () {
          var odometer = $scope.servicePricingTool.vehicle.Odometer;

          if (odometer) {
            return !validators.Odometer.pattern.test(odometer);
          }

          return false;
        };

        /**
         * isValidRego - determines if the registration number is valid when the user has entered something
         *
         * @return {boolean} returns true if the regex matches, returns false if the regex doesn't match or the field is empty
         */
        $scope.servicePricingTool.isValidRego = function () {
          var rego = $scope.servicePricingTool.vehicle.Rego;

          if (rego) {
            return validators.Rego.pattern.test(rego);
          }

          return false;
        };

        /**
         * isInvalidRego - determines if the registration number is invalid when the user has entered something
         *
         * @return {boolean} returns true if the regex doesn't match, returns false if the regex matches or the field is empty
         */
        $scope.servicePricingTool.isInvalidRego = function () {
          var rego = $scope.servicePricingTool.vehicle.Rego;

          if (rego) {
            return !validators.Rego.pattern.test(rego);
          }

          return false;
        };

        /**
         * isValidVin - determines if the VIN is valid when the input length is 17
         *
         * @return {boolean} returns true if the regex matches, returns false if the regex doesn't match or the field is empty/incomplete
         */
        $scope.servicePricingTool.isValidVin = function () {
          var vin = $scope.servicePricingTool.vehicle.Vin;
          return VIN.isValid(vin);
        };

        /**
         * isInvalidVin - determines if the VIN is invalid when the input length is 17
         *
         * @param  {boolean} focused true if the user is currently focused on the input
         * @return {boolean} returns true if the regex doesn't match, returns false if the regex matches or the field is empty/incomplete
         */
        $scope.servicePricingTool.isInvalidVin = function (focused) {
          var vin = $scope.servicePricingTool.vehicle.Vin;

          if (!focused && vin) {
            return !VIN.isValid(vin);
          }

          return false;
        };

        /**
         * isFormReady - returns true when the form is active and ready to be used
         *
         * @return {boolean}    true when the form is active and ready to be used
         */
        $scope.servicePricingTool.isFormReady = function () {
          return !$scope.servicePricingTool.showingQuote && !$scope.servicePricingTool.loadingState.isQuoteLoading;
        };

        /**
         * isQuoteReady - returns true when the pricing page is active and ready to be used
         *
         * @return {boolean}    true when the pricing page is active and ready to be used
         */
        $scope.servicePricingTool.isQuoteReady = function () {
          return (
            $scope.servicePricingTool.hasCompleteServiceQuote() &&
            !$scope.servicePricingTool.loadingState.isQuoteLoading
          );
        };

        /**
         * isTSG - If this method returns true, the users will be directed to a different Find a Dealer link with dealers who have
         *         not opted in for pricing transparency excluded from the results
         *
         * @return {boolean}    true when the serviceType is 'TSG'
         */
        $scope.servicePricingTool.isTSG = function () {
          return (
            $scope.servicePricingTool.vehicle.SelectedService &&
            $scope.servicePricingTool.vehicle.SelectedService.servicePricingType.toUpperCase() === "TSG"
          );
        };

        /**
         * setModel - select the model from the modal overlay menu
         *            causes the grade list to be populated and enabled
         *
         * @param {string} vehicleModelName the name of the model
         * @return {void}
         */
        $scope.servicePricingTool.setModel = function (vehicleModelName) {
          var foundModel = $scope.servicePricingTool.vehicleListings.ModelsList.filter(function (model) {
            return model.Name === vehicleModelName;
          });

          if (foundModel.length) {
            $scope.servicePricingTool.vehicle.Model = foundModel[0];
            $scope.servicePricingTool.setGradesByModel();
            $rootScope.$broadcast("modal-close", "servicePricingTool-modelmenu");
          }
        };

        /**
         * setGradesByModel - sets the grades by a particular model
         *
         * @return {void}
         */
        $scope.servicePricingTool.setGradesByModel = function () {
          $scope.servicePricingTool.vehicleListings.GradesList = $scope.servicePricingTool.vehicle.Model.Grades;
          $scope.servicePricingTool.vehicleListings.VariantsList = null;
        };

        /**
         * setVariantsByGrade - sets a list of variants by grade. this is triggered when the user selects
         *                      either a model from the modal, or a grade from the dropdown
         *
         * @return {void}
         */
        $scope.servicePricingTool.setVariantsByGrade = function () {
          var promise = $.Deferred();

          $scope.servicePricingTool.vehicleListings.VariantsList = null;

          /*
           * ng-change is fired when a model is chosen, so we only want
           * to call getVariants() if a grade has been selected
           */
          if ($scope.servicePricingTool.vehicle.Grade) {
            $scope.servicePricingTool.loadingState.isVariantLoading = true;

            var variantsPromise = function (response) {
              $scope.servicePricingTool.loadingState.isVariantLoading = false;

              if (response.status !== HTTP_OK) {
                return promise.reject(response);
              }

              var results = response.data.Data;

              $scope.servicePricingTool.vehicleListings.VariantsList = results;

              if (results.length === 1) {
                $scope.servicePricingTool.vehicle.Variant = results[0];
              }

              return promise.resolve(response);
            };

            $scope.servicePricingTool.resetErrorState();

            getVariants($scope.servicePricingTool.vehicle.Grade.GradeId)
              .then(variantsPromise, handleError)
              .catch(handleError);
          }
        };

        /**
         * showServiceOptionsRego - displays the search by rego form
         *
         * @return {void}
         */
        $scope.servicePricingTool.showServiceOptionsRego = function () {
          $scope.servicePricingTool.showingServiceOptions = $scope.servicePricingTool.tabs.Rego;
        };

        /**
         * showServiceOptionsModel - displays the search by model form
         *
         * @return {void}
         */
        $scope.servicePricingTool.showServiceOptionsModel = function () {
          $scope.servicePricingTool.showingServiceOptions = $scope.servicePricingTool.tabs.Model;
        };

        /**
         * showServiceOptionsVin - displays the search by VIN form
         *
         * @return {void}
         */
        $scope.servicePricingTool.showServiceOptionsVin = function () {
          $scope.servicePricingTool.showingServiceOptions = $scope.servicePricingTool.tabs.Vin;
        };

        /**
         * showModelModal - displays the modal listing overlay
         *
         * @return {void}
         */
        $scope.servicePricingTool.showModelModal = function () {
          $scope.servicePricingTool.resetErrorState();
          $rootScope.$broadcast("modal-open", "servicePricingTool-modelmenu");
          $scope.servicePricingTool.vehicle.Grade = null;
          $scope.servicePricingTool.vehicle.Variant = null;
        };

        /**
         * accordionRepeatDone - Called when an ng-repeat finishes rendering the last element.
         *
         * @return {void}
         */
        $scope.servicePricingTool.accordionRepeatDone = function () {
          $rootScope.$broadcast("accordion-repeat-done");
        };

        /**
         * track - Pushes user actions and events to the analytics data layer
         *
         * @param  {string} event               the event (e.g. 'gaClick')
         * @param  {string} action              the event action (e.g. 'Rego')
         * @param  {string} label               the event label (e.g. 'Rego Validated');
         * @param  {Array}  replacementStrings  an array of strings to replace tokens in the action or label arguments
         * @param  {Object} [extraProps]        extra properties to include on the tracking object
         * @return {void}
         */
        $scope.servicePricingTool.track = function (event, action, label, replacementStrings, extraProps) {
          var props = {
            event: event,
            eventCategory: "service pricing tool",
            eventAction: $filter("formatArgs")(action, replacementStrings),
            eventLabel: $filter("formatArgs")(label, replacementStrings),
          };

          if (extraProps) {
            angular.merge(props, extraProps);
          }

          $analytics.eventTrack(event, props);
        };

        /**
         * updateQuote - Updates the pricing quote if the user enters a valid odometer reading.
         *               Validates odometer input to ensure the value is less than 150000.
         *
         * @return {void}
         */
        $scope.servicePricingTool.updateQuote = function () {
          var tabs = $scope.servicePricingTool.tabs;
          var tab = $scope.servicePricingTool.getSelectedTabName();
          var odometer = $scope.servicePricingTool.vehicle.Odometer;

          if ($scope.servicePricingTool.isQuoteReady()) {
            $scope.servicePricingTool.track(
              "gaClick",
              $filter("formatArgs")("{0} - Quote", [tab]),
              $filter("formatArgs")("Odometer - {0}", [odometer])
            );
          }

          $scope.servicePricingTool.vehicle.SelectedService = null;
          $scope.servicePricingTool.vehicle.SelectedServiceCode = null;
          $scope.servicePricingTool.loadingState.isQuoteUpdating = true;

          switch ($scope.servicePricingTool.showingServiceOptions) {
            case tabs.Rego:
              $scope.servicePricingTool.getServiceQuoteByRego(true);
              break;
            case tabs.Model:
              $scope.servicePricingTool.getServiceQuoteByModel(true);
              break;
            case tabs.Vin:
              $scope.servicePricingTool.getServiceQuoteByVin(true);
              break;
            default:
          }
        };

        // Private methods

        /**
         * cancelExistingPromise - If the API request is particularly slow, the user may
         *                         repeatedly hit the submit button, thereby
         *                         creating a queue of pending HTTP requests
         *
         *                         This function silently cancels any existing HTTP request
         *                         by rejecting the promise.
         *
         * @return {void}
         */
        function cancelExistingPromise() {
          if ($scope.servicePricingTool.loadingPromise) {
            $scope.servicePricingTool.isHttpRequestCancelled = true;
            $scope.servicePricingTool.loadingPromise.cancel();
          }
        }

        /**
         * getVehicleLongDescription - Gets a string formatted for the email
         *
         * @private
         * @return {string} vehicle description
         */
        function getVehicleLongDescription() {
          var spc = " ";
          return $scope.servicePricingTool.vehicle.VehicleInfo.manufacturer
            .concat(spc, $scope.servicePricingTool.vehicle.VehicleInfo.model)
            .concat(spc, $scope.servicePricingTool.vehicle.VehicleInfo.grade);
        }

        /**
         * getModels - Gets a distinct list of models grouped by body type
         *
         * @private
         * @return {void}
         */
        function getModels() {
          var bodytypesList = angular.fromJson($attrs.bodytypesList);

          if (!Array.isArray(bodytypesList)) {
            bodytypesList = [];
          }

          var flatData = [];
          
          bodytypesList.forEach(function (bt) {
            if (bt.Models && Array.isArray(bt.Models)) {
              bt.Models.forEach(function (model) {
                flatData.push(model);
              });
            }
          });
          $scope.servicePricingTool.vehicleListings.ModelsList = flatData;
        }

        /**
         * getVariants - Loads the variant lists for a grade into the type dropdown list
         *
         * @private
         * @param  {number} gradeId the gradeId
         * @return {void}
         */
        function getVariants(gradeId) {
          var url = $filter("formatArgs")(ToyotaConsts.API.Vehicle.VariantsByGradeId, [gradeId]);
          return API.get(url).then(
            // success
            function (response) {
              if (response.data.Total > 0) {
                return response;
              }

              return {
                status: "NO_VARIANT",
              };
            },
            // failed
            function () {
              return {
                status: "NO_VARIANT",
              };
            }
          );
        }

        /**
         * getServiceQuote - get vehicleinfo and service details by vin or rego or model
         *                   displays service quote panel on success
         * @param {string} urlVehicleInfo     the vehicle info API URL with parameters included
         * @param {string} urlServiceDetails  the scheduled services API URL with parameters included
         * @param {string} updateOnly         if true, we only call the scheuled services API as we already have the vehicle info
         * @private
         * @return {Promise}    service quote
         */
        function getServiceQuote(urlVehicleInfo, urlServiceDetails, updateOnly) {
          var accessToken = $scope.servicePricingTool.tokenService.accessToken;
          var tabs = $scope.servicePricingTool.tabs;
          var promise = $.Deferred();

          $scope.servicePricingTool.loadingState.isQuoteLoading = !updateOnly;
          $scope.servicePricingTool.loadingState.isQuoteUpdating = updateOnly;

          var vehiclePromise = function (response) {
            if (response.status !== HTTP_OK) {
              switch ($scope.servicePricingTool.showingServiceOptions) {
                case tabs.Rego:
                  $scope.servicePricingTool.track("gaClick", "Rego", "Rego Error");
                  break;
                case tabs.Model:
                  $scope.servicePricingTool.track("gaClick", "Model", "Model Error");
                  break;
                case tabs.Vin:
                  $scope.servicePricingTool.track("gaClick", "Vin", "Vin Error");
                  break;
                default:
              }

              return promise.reject(response);
            }

            var vInfo = response.data;
            var hasImages = vInfo.images && vInfo.images.length > 0;
            var srcset = [];
            var images = [];

            $scope.servicePricingTool.vehicle.VehicleInfo = vInfo;

            if (hasImages) {
              images = vInfo.images
                .filter(function (image) {
                  /*
                   * Only add 3/4 right facing images
                   * OSB aren't currently passing through the orientation details from
                   * Mulesoft, so unfortunately we have to test against the extension
                   */
                  var extensionPattern = /(.*)_003\.(jpg|png)$/g;
                  return extensionPattern.test(image.link);
                })
                .map(function (image) {
                  var pattern = /(\d+)x(\d+)/g;
                  var matches = pattern.exec(image.size);
                  var width = parseInt(matches[1]);

                  return {
                    srcsetUrl: $filter("formatArgs")("{0} {1}w", [image.link, width]),
                    url: image.link,
                  };
                });

              srcset = images.map(function (image) {
                return image.srcsetUrl;
              });
            }

            $scope.servicePricingTool.vehicle.VehicleInfo.srcset = srcset.join(",");
            $scope.servicePricingTool.vehicle.VehicleInfo.hasImage = srcset.length > 0;

            if (srcset.length) {
              $timeout(function () {
                window.picturefill({ reevaluate: true });
              });
            }

            switch ($scope.servicePricingTool.showingServiceOptions) {
              case tabs.Rego:
                $scope.servicePricingTool.track("gaClick", "Rego", "Rego Validated");
                break;
              case tabs.Model:
                $scope.servicePricingTool.track("gaClick", "Model", "Model Validated");
                break;
              case tabs.Vin:
                $scope.servicePricingTool.track("gaClick", "Vin", "Vin Validated");
                break;
              default:
            }

            return getServiceDetails(accessToken, urlServiceDetails);
          };

          var servicePromise = function (response) {
            if (response.status !== HTTP_OK) {
              return promise.reject(response);
            }

            $scope.servicePricingTool.vehicle.ServiceDetails = response.data;
            setScheduledServices();

            var vehicleModel = { model: $scope.servicePricingTool.vehicle.VehicleInfo.model };
            var odometer = $scope.servicePricingTool.vehicle.Odometer;

            if (odometer) {
              $scope.servicePricingTool.track("gaFormSubmission", "form - odometer", odometer, undefined, vehicleModel);
            } else {
              switch ($scope.servicePricingTool.showingServiceOptions) {
                case tabs.Rego:
                  $scope.servicePricingTool.track(
                    "gaFormSubmission",
                    "form - Registration",
                    "success",
                    undefined,
                    vehicleModel
                  );
                  break;
                case tabs.Model:
                  $scope.servicePricingTool.track(
                    "gaFormSubmission",
                    "form - Model",
                    "success",
                    undefined,
                    vehicleModel
                  );
                  break;
                case tabs.Vin:
                  $scope.servicePricingTool.track("gaFormSubmission", "form - Vin", "success", undefined, vehicleModel);
                  break;
                default:
              }
            }

            return promise.resolve(response);
          };

          var finalPromise = function () {
            $scope.servicePricingTool.loadingPromise = null;
            $scope.servicePricingTool.loadingState.isQuoteLoading = false;
            $scope.servicePricingTool.loadingState.isQuoteUpdating = false;
            $scope.servicePricingTool.quoteDate = new Date();
          };

          $scope.servicePricingTool.resetErrorState();

          // This kicks off the promise chain
          if (updateOnly) {
            return getServiceDetails(accessToken, urlServiceDetails)
              .then(servicePromise, handleError)
              .then(finalPromise)
              .then(handleError);
          }

          return getVehicleInfo(accessToken, urlVehicleInfo)
            .then(vehiclePromise, handleError)
            .then(servicePromise, handleError)
            .then(finalPromise)
            .catch(handleError);
        }

        /**
         * getVehicleInfo - gets vehicle information
         *
         * @private
         * @param  {string} accessToken  the authentication token
         * @param  {string} url the target url to use including query params
         * @return {Promise}    vehicle info
         */
        function getVehicleInfo(accessToken, url) {
          return API.get(url, { Authorization: "Bearer " + accessToken }).then(OK, BadRequest);
        }

        /**
         * getServiceDetails - gets a quote for the vehicle
         *
         * @private
         * @param  {string} accessToken  the authentication token
         * @param  {string} url the target url to use including query params
         * @return {Promise}    service details
         */
        function getServiceDetails(accessToken, url) {
          return API.get(url, { Authorization: "Bearer " + accessToken }).then(OK, BadRequest);
        }

        /**
         * OK - Function that is called when a vehicle info or scheduled service promise is fulfilled
         *
         * @param  {Object} response the JSON response from the API
         * @return {Object}          either the response object, or an error message
         */
        function OK(response) {
          if (response.data) {
            return response;
          }

          return {
            status: 500,
          };
        }

        /**
         * BadRequest - Function that is called when a vehicle info or scheduled service promise is rejected
         *
         * @param  {Object} response the JSON response from the API
         * @return {Object}          an error message
         */
        function BadRequest(response) {
          if ($scope.servicePricingTool.isHttpRequestCancelled) {
            $scope.servicePricingTool.isHttpRequestCancelled = false;
            return {
              status: "HTTP_REQUEST_CANCELLED",
            };
          }

          if (response.status === HTTP_NOT_FOUND) {
            return {
              status: "NOT_FOUND",
            };
          }

          return {
            status: "SERVER_ERROR",
          };
        }

        /**
         * handleError - updates the error state, which is then referenced by
         *               $scope.servicePricingTool.hasErrorWithStatus
         *
         * @private
         * @param {object} err  error
         * @returns {void}
         */
        function handleError(err) {
          $scope.servicePricingTool.showingQuote = false;
          $scope.servicePricingTool.loadingState.isQuoteLoading = false;
          $scope.servicePricingTool.loadingState.isQuoteUpdating = false;
          $scope.servicePricingTool.errorState = {
            serviceOption: $scope.servicePricingTool.showingServiceOptions,
            error: err,
          };
        }

        /**
         * isFirstOrDefaultService - Returns true if the current service code is the
         *                           first item in the list.
         *
         *                           Returns false if the service code is null or the
         *                           item is not the first in the list.
         *
         *                           This function is used to determine whether or note
         *                           to append the service parameter to the querystring.
         *                           If we don't check for this, while naviating back/forward
         *                           the user will see the the default service
         *                           twice instead of once.
         *
         * @param  {string} serviceCode the servie code
         * @return {boolean} true if the current service code is valid and is the first one
         *                   in the list
         */
        function isFirstOrDefaultService(serviceCode) {
          var serviceIntervals = $scope.servicePricingTool.vehicleListings.ServiceIntervals;

          if (serviceIntervals) {
            return (
              serviceIntervals.filter(function (service, index) {
                return service.code === serviceCode && index === 0;
              }).length === 1
            );
          }

          return false;
        }

        /**
         * resetErrorState - Clears the error state
         *
         * @return {void}
         */
        $scope.servicePricingTool.resetErrorState = function () {
          $scope.servicePricingTool.errorState = null;
        };

        /**
         * setScheduledServices - populate dropdown of service intervals and find recommended service
         *
         * @private
         * @return {void}
         */
        function setScheduledServices() {
          var services = $scope.servicePricingTool.vehicle.ServiceDetails.service;

          if (services) {
            services = services.map(function (interval) {
              var formattedPeriod = interval.name + " months or " + $filter("formatNumber")(interval.kilometers) + "km";
              return angular.extend({}, interval, { formattedName: formattedPeriod });
            });

            // Get the first recommended otherwise default is first one
            var recommendedService = services.filter(function (service) {
              return service.recommended;
            });

            var selectedService = recommendedService[0] || services[0];

            // Add the (SERVICE_INTERVALS_LIMIT - 1) after the recommended one
            var startIndex = services.indexOf(selectedService);
            var serviceIntervals;

            if ($scope.servicePricingTool.showingServiceOptions === $scope.servicePricingTool.tabs.Model) {
              serviceIntervals = services.filter(function (service) {
                return service.servicePricingType === toyotaServiceAdvantage;
              });
            } else {
              serviceIntervals = services.slice(startIndex, startIndex + SERVICE_INTERVALS_LIMIT);
            }

            // determine if selection was made previously via the query settings
            var preselectedService = services.filter(function (service) {
              return service.code === $scope.servicePricingTool.vehicle.SelectedServiceCode;
            });

            selectedService = preselectedService[0] || recommendedService[0] || services[0];

            $scope.servicePricingTool.vehicleListings.ServiceIntervals = serviceIntervals;
            $scope.servicePricingTool.vehicle.SelectedService = selectedService;

            expandSelectedService();
          }
        }

        /**
         * setVehicleValues - reset all values in servicePricingTool.vehicle
         *
         * @private
         * @param  {object}  newValues      object with minimal field values to set
         * @param  {boolean} preserveQuote  if true, we should keep the vehicle info
         * @return {object} vehicle values
         */
        function setVehicleValues(newValues, preserveQuote) {
          var nullValues = {
            Rego: null,
            State: null,
            Model: null,
            Grade: null,
            Variant: null,
            Vin: null,
            VehicleInfo: preserveQuote ? $scope.servicePricingTool.vehicle.VehicleInfo : null,
            ServiceDetails: preserveQuote ? $scope.servicePricingTool.vehicle.ServiceDetails : null,
            SelectedService: preserveQuote ? $scope.servicePricingTool.vehicle.SelectedService : null,
            SelectedServiceCode: null,
            Odometer: null,
          };

          return angular.merge(nullValues, newValues);
        }

        /**
         * expandSelectedService - Adds extra properties to the SelectedService object such as
         *                         unique service action item names, sorted action items, and
         *                         service type name.
         *
         *                         Called from setScheduledServices and a $watch task on
         *                         $scope.servicePricingTool.vehicle.SelectedService
         *
         * @return {void}
         */
        function expandSelectedService() {
          // Create the sorted list of service actions
          $scope.servicePricingTool.vehicle.SelectedService.serviceDetails.forEach(function (serviceDetails) {
            serviceDetails.serviceActions = serviceDetails.serviceDescription
              .map(function (description) {
                return description.action;
              })
              .filter(function (action, index, actions) {
                return actions.indexOf(action) === index;
              })
              .sort(function (a, b) {
                var orderA = $scope.servicePricingTool.serviceActionTypesOrder[a] || -1;
                var orderB = $scope.servicePricingTool.serviceActionTypesOrder[b] || -1;

                if (orderA > orderB) {
                  return -1;
                }

                if (orderA < orderB) {
                  return 1;
                }

                return 0;
              });
          });
        }

        /**
         * refreshAccessToken - renew the accesstoken after it expires
         *
         * @return {void}
         */
        $scope.servicePricingTool.refreshAccessToken = function () {
          var urlAuthentication = $filter("formatArgs")(ToyotaConsts.API.Authentication.Token, ["OSB"]);
          API.get(urlAuthentication).then(
            // success
            function (response) {
              if (response.data.Data) {
                $scope.servicePricingTool.tokenService.accessToken = response.data.Data;
              }
            },
            // failed
            function () {
              $scope.servicePricingTool.tokenService.accessToken = null;
            }
          );
        }

        /**
         * setDefaults - sets the default values
         *
         * @private
         * @return {void}
         */
        function setDefaults() {
          $scope.servicePricingTool.showingServiceOptions = $scope.servicePricingTool.tabs.Rego;
          $scope.servicePricingTool.showingQuote = false;
          $scope.servicePricingTool.emailSent = false;
          $scope.servicePricingTool.vehicleListings.PricingTypeList = angular.fromJson($attrs.servicepricingtypeList);
        }

        /**
         * init - the initialisation function
         *
         * @private
         * @return {void}
         */
        function init() {
          getModels();
          setDefaults();

          // Refresh the access token
          $interval($scope.servicePricingTool.refreshAccessToken, $scope.servicePricingTool.tokenService.interval);
        }

        this.$onInit = init;
      },
    ];

    return {
      scope: true,
      restrict: "A",
      controller: controller,
      controllerAs: "servicePricingToolController",
      link: function ($scope, $element) {
        var $modalBody = $element.find(".ty-modal-panel__body");
        var $findADealer = $element.find(".ty-service-pricing-tool__dealer-image a");

        var resetTopScroll = function () {
          $modalBody.scrollTop(0);
        };

        // Event listener for the modal-open event
        $scope.$on("modal-open", function () {
          resetTopScroll();
        });

        $findADealer.on("click", function () {
          var tab = $scope.servicePricingTool.getSelectedTabName();
          $scope.servicePricingTool.track("gaClick", "{0} - Quote", "Find a Dealer", [tab]);
        });
      },
    };
  });
})(window.angular, window.ToyotaConsts);
